export const RESIZER_SIZE = 10;
export const RESIZER_GAP = 16;
